// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import gameConfig from "../../../../../engines/configs/gameConfig";
import O1HD from "../../../../../engines/gameEngine";
import { GeneralKind } from "../../../../define/GeneralKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { backPackEventMap } from "../../../config/BackpackEventConfig";
import NormalGameManager from "../../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SuperPowerSelect1 extends BasePopUpLayer {

    @property(cc.Label)
    labelName: cc.Label = null;
    
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        let goodsId = GeneralKind.PropId.AD_CARD;
        let count = gameConfig.SUPER_POWER_AD_CARD_COUNT;
        NormalGameManager._instance.onPushGoods(goodsId, count);

        let backItem = backPackEventMap()[goodsId];
        this.labelName.string = backItem.name + '×' + count;
    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu");

        O1HD.emit(MessageEventKind.EventName.REFRESH_AD_CARD_COUNT);
        this.destroyNode();
        this._carryData.parent.showEndUI('我们下次再见');
    }

    // update (dt) {}
}
